import React, { Component } from 'react'
import { action, computed } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import inject from 'helpers/inject'
import formField from 'helpers/formField'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'
import CardTitle from 'components/CardTitle'

import AuthService from 'services/auth'

import updateAccount from 'tasks/updateAccount'
import getCurrentUser from 'tasks/getCurrentUser'

import styles from 'styles/components/ProfileForm'

@withStyles(styles)
@observer
export default class extends Component {

  auth = inject(AuthService)

  @computed
  get fields() {
    const { email = '', firstName = '', lastName = '' } = this.auth.user || {}

    return [

      formField({
        value: email,
        label: 'Адрес электронной почты',
        type: 'email',
        name: 'email',
        disabled: true
      }),

      formField({
        value: firstName,
        label: 'Имя',
        name: 'firstName',
        validations: {
          presence: true,
          format: { pattern: '[А-Я-Ё]+', flags: 'gi', message: 'Поле может содержать только русские буквы'}
        }
      }),

      formField({
        value: lastName,
        label: 'Фамилия',
        name: 'lastName',
        validations: {
          presence: true,
          format: { pattern: '[А-Я-Ё]+', flags: 'gi', message: 'Поле может содержать только русские буквы'}
        }
      })

    ]
  }

  @computed
  get hasErrors() {
    return this.fields.filter(field => field.hasErrors).length > 0
  }

  render() {
    const { classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <CardTitle title='Информация о пользователе' />
        <div className={ classes.wrapper } >
          <CardContent className={ classes.content } >

            { this.fields.map(( field, index ) => (
              <FormInput
                field={ field }
                key={ index }
                TextFieldProps={{
                  fullWidth: true
                }}
              />
            ))}

          </CardContent>
          <CardActions className={ classes.actions } >
            <AsyncButton
              action={ this.handleSave }
              ButtonProps={{
                fullWidth: true,
                raised: true,
                color: 'primary'
              }}
            />
          </CardActions>
        </div>
      </Card>
    )
  }

  @action.bound
  async handleSave() {
    this.fields.forEach(field => field.validate())
    if (this.hasErrors) throw new Error()
    const firstName = this.fields.find(field => field.name === 'firstName').value
    const lastName = this.fields.find(field => field.name === 'lastName').value
    await updateAccount.perform(this.auth.user.id, { firstName, lastName })
    await getCurrentUser.perform()
  }

}



// WEBPACK FOOTER //
// ./src/components/ProfileForm.js